import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const fleetVehicles = [
    {
        image: "/images/mercedes-benz-12-passengers.png",
        title: "Mercedes-Benz Sprinter Van",
        capacity: "12 Passengers",
        description:
            "A premium transportation solution featuring spacious seating, modern amenities, and exceptional comfort for executive travel, airport transportation, and private group trips.",
    },
    {
        image: "/images/mercedes-benz-15-passengers.png",
        title: "Mercedes-Benz Sprinter Van",
        capacity: "15 Passengers",
        description:
            "Ideal for larger groups seeking luxury transportation with generous legroom, comfortable seating, and a smooth travel experience.",
    },
    {
        image: "/images/transit-mid-roof.png",
        title: "Ford Transit Mid Roof",
        capacity: "15 Passengers",
        description:
            "A versatile passenger van perfect for airport transfers, corporate transportation, and event travel while providing excellent passenger comfort.",
    },
    {
        image: "/images/transit-high-roof-xlt.png",
        title: "Ford Transit High Roof XLT",
        capacity: "15 Passengers",
        description:
            "Premium high-roof configuration with enhanced passenger accessibility, spacious interiors, and superior travel comfort.",
    },
    {
        image: "/images/transit-high-roof.png",
        title: "Ford Transit High Roof",
        capacity: "15 Passengers",
        description:
            "Designed for group transportation with additional headroom, comfortable seating, and ample luggage capacity for longer journeys.",
    },
];

const fleetFeatures = [
    {
        icon: "airline_seat_recline_normal",
        title: "Comfortable Seating",
    },
    {
        icon: "luggage",
        title: "Luggage Space",
    },
    {
        icon: "ac_unit",
        title: "Climate Controlled",
    },
    {
        icon: "groups",
        title: "Group Friendly",
    },
    {
        icon: "shield",
        title: "Safety Focused",
    },
    {
        icon: "schedule",
        title: "Reliable Service",
    },
];

const Fleet = () => {
    return (
        <section className="bg-primary">
            <Helmet>
                <title>Our Fleet | Mercedes Sprinter & Ford Transit Vans | Velox Charter</title>

                <meta
                    name="description"
                    content="Explore Velox Charter's modern fleet of Mercedes-Benz Sprinter and Ford Transit passenger vans. Perfect for airport transfers, corporate transportation, weddings, private events, and comfortable group travel across the USA."
                />
            </Helmet>

            <div className="max-w-7xl mx-auto px-4">
                <div className="h-[220px] md:h-[280px] flex items-center justify-center">
                    <h1 className="text-white text-4xl md:text-6xl font-bold text-center">
                        Our Fleet
                    </h1>
                </div>
            </div>

            <section className="bg-[#F9FAFB] py-16 md:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    <div className="text-center">
                        <h2 className="text-4xl md:text-5xl font-semibold text-black">
                            Premium Passenger Vans For Group Transportation
                        </h2>

                        <p className="mt-6 max-w-3xl mx-auto text-gray-500 text-base md:text-lg leading-relaxed">
                            Velox Charter specializes in premium passenger van transportation, offering a
                            modern fleet of Mercedes-Benz Sprinter and Ford Transit vans. Our vehicles
                            are designed to provide safe, comfortable, and reliable transportation for
                            airport transfers, corporate travel, weddings, private events, and small group transportation.
                        </p>
                    </div>

                    <div className="mt-14 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">

                        {fleetVehicles.map((vehicle, index) => (
                            <div
                                key={index}
                                className="
                                    bg-white
                                    rounded-[24px]
                                    overflow-hidden
                                    border
                                    border-[#E5E7EB]
                                    hover:shadow-xl
                                    transition-all
                                    duration-300
                                    hover:-translate-y-2
                                "
                            >
                                <img
                                    src={vehicle.image}
                                    alt={vehicle.title}
                                    className="w-full h-[250px] object-cover"
                                />

                                <div className="p-6">

                                    <h3 className="text-2xl font-semibold text-secondryBlue">
                                        {vehicle.title}
                                    </h3>

                                    <p className="mt-2 text-primary font-medium">
                                        {vehicle.capacity}
                                    </p>

                                    <p className="mt-4 text-gray-500 leading-7">
                                        {vehicle.description}
                                    </p>

                                </div>
                            </div>
                        ))}

                    </div>

                </div>
            </section>

            <section className="bg-[#F5F5F5] py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    <div className="items-center">
                        <div>

                            <h2 className="text-[36px] md:text-[52px] font-semibold text-black leading-tight">
                                Premium Vans Designed For Comfortable Group Travel
                            </h2>

                            <div className="mt-6 space-y-5 text-[#666666] leading-8 text-base md:text-lg">
                                <p>
                                    At Velox Charter, we focus exclusively on premium passenger van transportation. Our Mercedes-Benz Sprinter
                                    and Ford Transit fleet provides the perfect balance of comfort, efficiency, and flexibility for groups traveling together.
                                </p>

                                <p>
                                    Whether you're arranging airport transportation, executive travel, wedding guest transportation,
                                    sporting event transportation, or private group outings, our vans offer spacious seating and dependable service.
                                </p>

                                <p>
                                    By specializing in passenger vans, we're able to provide a more personalized travel experience while
                                    ensuring every passenger enjoys a safe and comfortable journey.
                                </p>
                            </div>

                        </div>

                    </div>

                </div>
            </section>

            <section className="bg-white py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                    <div className="text-center">

                        <h2 className="text-4xl md:text-5xl font-semibold text-black">
                            Why Our Fleet Stands Out
                        </h2>

                        <p className="mt-6 max-w-3xl mx-auto text-gray-500 text-base md:text-lg leading-relaxed">
                            Our vehicles are equipped and maintained to provide an
                            exceptional travel experience while ensuring passenger safety,
                            comfort, and reliability.
                        </p>

                    </div>

                    <div className="mt-14 grid grid-cols-2 lg:grid-cols-3 gap-6">

                        {fleetFeatures.map((feature, index) => (
                            <div
                                key={index}
                                className="
                                    bg-[#F8FAFC]
                                    border
                                    border-[#E5E7EB]
                                    rounded-[20px]
                                    p-8
                                    text-center
                                    hover:shadow-lg
                                    transition-all
                                    duration-300
                                "
                            >
                                <span className="material-symbols-outlined text-[42px] text-secondryBlue">
                                    {feature.icon}
                                </span>

                                <h3 className="mt-4 text-lg md:text-xl font-medium text-black">
                                    {feature.title}
                                </h3>
                            </div>
                        ))}

                    </div>

                </div>
            </section>

            <section className="bg-primary py-20">
                <div className="max-w-5xl mx-auto px-4 text-center">

                    <h2 className="text-white text-4xl md:text-5xl font-semibold">
                        Find The Perfect Vehicle For Your Next Trip
                    </h2>

                    <p className="mt-6 text-white/80 text-base md:text-lg max-w-3xl mx-auto">
                        Whether you're traveling with a small executive team or a large
                        group, Velox Charter has the right transportation solution to ensure
                        a comfortable and reliable journey.
                    </p>

                    <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
                        <Link
                            to="/contact-us"
                            className="
        inline-block
        bg-white
        text-primary
        px-8
        py-4
        rounded-full
        font-semibold
        hover:scale-105
        transition-all
    "
                        >
                            Contact Us
                        </Link>
                    </div>
                </div>
            </section>

        </section>
    );
};

export default Fleet;